import * as Yup from 'yup';

export default Yup.object().shape({
  selectedEquipments: Yup.array()
    .min(1, 'SCHEMA_ERRORS.AT_LEAST_ONE_EQUIPMENT_REQUIRED')
    .required('SCHEMA_ERRORS.EQUIPMENTS_REQUIRED')
});
